var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:'entity-folder-tree-view__collapse-button',style:(`margin-left: ${_vm.levelOfNesting}rem;`),on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }